export default __webpack_public_path__ + "static/media/no-existing-users-illustration.e49c1391.svg";